import { apiEndpoint } from '../_config/config'
import { handleResponse } from '.'
import axios from 'axios'

export default function reportError (data) {
  const config = {
    method: 'POST',
    url: `${apiEndpoint}/api/frontend/error/new`,
    data: JSON.stringify(data)
  }

  axios(config).then(handleResponse)
  // .catch(
  //   error => {
  //     // console.log('Error while reporting error: ', error)
  //   }
  // )
}
